<p-table
  [value]="this.displayedThreads"
  [rowHover]="true"
  styleClass="p-datatable-sm supervisor-thread-table"
  [tableStyle]="{'table-layout': 'fixed', 'width': '100%'}"
  [lazy]="true"
  [totalRecords]="this.supervisorService.totalThreads"
  [rows]="20"
  [paginator]="true"
  [rowsPerPageOptions]="[10, 20, 50]"
  paginatorDropdownAppendTo="body"
  (onLazyLoad)="this.onLazyLoad($event)"
>
  <ng-template
    pTemplate="body"
    let-thread
  >
    <tr
      style="cursor: pointer"
      (click)="this.selectThread(thread.context.botid, thread.threadId)"
      [ngClass]="{
        'selected-thread': this.isThreadSelected(thread),
        'broadcast-thread': this.threadBroadcastService.selectedThreadsSet.has(thread.threadId)
      }"
    >
      <td
        style="width: 2.5rem; vertical-align: top; padding-top: 0.85rem"
        (click)="$event.stopPropagation()"
      >
        <p-checkbox
          [binary]="true"
          [ngModel]="this.threadBroadcastService.selectedThreadsSet.has(thread.threadId)"
          (onChange)="this.selectThreadForBroadcast(thread.threadId)"
        />
      </td>
      <td>
        <div class="d-flex align-items-center gap-2 mb-1">
          <span
            class="status-dot"
            [ngClass]="this.threadOpen(thread.threadId) ? 'status-online' : 'status-offline'"
          ></span>
          <i
            class="ri-user-2-fill"
            [style.color]="this.getThreadColor(thread.context.user)"
          ></i>
          <span class="fw-semibold thread-username text-truncate">
            {{ this.supervisorService.getUserIdToName(thread.context.user) || '–' }}
          </span>
          <small class="text-muted ms-auto text-nowrap">
            {{ thread.created | date: 'dd.MM. HH:mm' }}
          </small>
        </div>
        <div
          class="d-flex align-items-center gap-1 mb-1"
          style="min-width: 0"
        >
          @let summary = this.supervisorService.getSummeryForThread(thread.threadId);
          <div
            class="thread-summary text-muted text-truncate flex-grow-1"
            [pTooltip]="summary?.content || ''"
            tooltipPosition="right"
            [showDelay]="400"
          >
            <i>{{ summary?.content || '—' }}</i>
          </div>
          @if (summary && !summary.finished) {
          <p-button
            [text]="true"
            [rounded]="true"
            severity="secondary"
            size="small"
            [disabled]="true"
            (click)="$event.stopPropagation()"
          >
            <i class="ri-reset-right-fill ri-loader"></i>
          </p-button>
          } @else {
          <p-button
            [text]="true"
            [rounded]="true"
            severity="secondary"
            size="small"
            [ngClass]="{'text-primary': this.supervisorService.threadSummeryIsOutdated(thread.threadId)}"
            (click)="$event.stopPropagation(); this.supervisorService.summarizeThread(thread.threadId)"
            icon="ri-reset-right-fill"
            i18n-pTooltip="@@summarize-thread"
            pTooltip="Zusammenfassung generieren"
            tooltipPosition="left"
          />
          }
        </div>
        <div class="d-flex align-items-center gap-2">
          <small class="text-muted">
            <i class="ri-chat-unread-line"></i>
            {{ this.supervisorService.getMessageCountPerThread(thread.threadId) }}
          </small>
          <small class="text-muted">
            &#8960; {{ this.supervisorService.getStatsForThread(thread.threadId).arith }}&nbsp;ms
          </small>
          @if (this.supervisorService.notificationCountAll(thread.threadId) > 0) {
          <p-tag
            class="ms-auto"
            [severity]="this.supervisorService.notificationUnsolved(thread.threadId) === 0 ? 'secondary' : 'danger'"
            icon="ri ri-megaphone-fill"
            [value]="this.supervisorService.notificationCountSolved(thread.threadId) + '/' + this.supervisorService.notificationCountAll(thread.threadId)"
          />
          }
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="2">
        <div class="d-flex flex-column align-items-center justify-content-center py-5 text-muted gap-2">
          <i
            class="ri-inbox-line"
            style="font-size: 2rem"
          ></i>
          <span i18n="@@supervisor-no-threads">Keine Chats vorhanden oder gefunden.</span>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>